<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {}
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/App.vue